import React from "react";
import { Link } from "react-router-dom";

import { games } from "../../data/matchups.js";

import styles from "./header.module.css";

const Header = ({ gameNumber }) => {
  let n = parseInt(gameNumber);

  let Prev = () =>
    gameNumber && games[n - 1] ? (
      <Link to={`/${n - 1}`} className={styles.prev}>
        ⇐
      </Link>
    ) : null;

  let Next = () =>
    gameNumber && games[n + 1] ? (
      <Link to={`/${n + 1}`} className={styles.next}>
        ⇒
      </Link>
    ) : null;

  return (
    <h1 className={styles.title}>
      <Prev />
      <Link to="/">BBTF Corona Draft Tourney</Link>
      <Next />
    </h1>
  );
};

export default Header;
